// extracted by mini-css-extract-plugin
export default {"container":"Radio_container__9ylRR","radio":"Radio_radio__cJbNV","dot":"Radio_dot__ohMiq","labelText":"Radio_labelText__ApQ4N"};